import { useQuery, useQueryClient } from "react-query";

const useWorkflowDetails = ({
  tenantId,
  id,
  moduleCode,
  role = "CITIZEN",
  serviceData = {},
  getStaleData = false,
  config = {},
  getTripData = false,
}) => {
  const queryClient = useQueryClient();

  const alwaysCallConfig = {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  };

  const { isLoading, error, isError, data } = useQuery(
    ["workFlowDetails", tenantId, id, moduleCode, role],
    () => Digit.WorkflowService.getDetailsById({ tenantId, id, moduleCode, role, getTripData }),
    getStaleData
      ? { staleTime: Infinity, ...config } // stale but persistent
      : { ...alwaysCallConfig, ...config } // always refetch
  );

  if (getStaleData) return { isLoading, error, isError, data };

  return {
    isLoading,
    error,
    isError,
    data,
    revalidate: () => queryClient.invalidateQueries(["workFlowDetails", tenantId, id, moduleCode, role]),
  };
};

export default useWorkflowDetails;
